import {$hostAuth} from "../http";

class CatalogsService{
    async getAll(){
        return await $hostAuth.get(`/api/categories?visible=1`);
    }
    async getOne(id){
        return await $hostAuth.get(`/api/categories/one?id=${id}`);
    }
    async getAllSub(){
        return await $hostAuth.get(`/api/categories/sub`);
    }

    async updateCategory(data){
        return await $hostAuth.patch(`/api/categories/`, data);
    }
    async updateSubCategory(data){
        return await $hostAuth.patch(`/api/categories/sub`, data);
    }
    async create(data){
        return await $hostAuth.post(`/api/categories/`, data);
    }
    async createSub(data){
        return await $hostAuth.post(`/api/categories/sub`, data);
    }
    async delete(id, isCategory){
        return await $hostAuth.delete(`/api/categories/?id=${id}&isCategory=${+isCategory}`);
    }
    async updateOrder(data){
        return await $hostAuth.post(`/api/categories/order`, data);
    }

}

export default new CatalogsService()